import { createContext, ReactElement, useState, useEffect } from "react";
import { Vendor } from "types/vendor";
import axios from "axios";


interface VendorContextProps {
  currentVendor: Vendor | null;
  handleUpdateVendor: (newVendor: Vendor) => void;
  updateMode?: boolean;
  handleUpdateVendorData?: (vendorKey:string, value:string) => void;
  updater: (vendor:any) => void;
  toggleUpdateModeButton: (editMode: boolean, refetch: any, vendorOverride?: Vendor, skipToggleUpdateMode?: boolean) => void;
  deleteVendor: (refetch:any) => void;
  hideVendorDetails: () => void;
  vendorDetailsHidden: boolean;
}

export const VendorContext = createContext<VendorContextProps>(
  {} as VendorContextProps
);

interface IProps {
  children: ReactElement;
}

export const VendorProvider = ({ children }: IProps) => {
  const [currentVendor, setCurrentVendor] = useState<Vendor | null>(null);
  const [updateMode, setUpdateMode] = useState(false);

  const [vendorDetailsHidden, setVendorDetailsHidden] = useState(false);

  const hideVendorDetails = () => setVendorDetailsHidden(!vendorDetailsHidden)

  const handleUpdateVendor = (newVendor: Vendor) => {
    setCurrentVendor(newVendor);
    setUpdateMode(false)

    return;
  };

  const updater = (vendor: any): Promise<void> => {
    setCurrentVendor(vendor);
    return Promise.resolve();
  };
  

  const toggleUpdateModeButton = async (
    editMode: boolean,
    refetch: any,
    vendorOverride?: Vendor,
    skipToggleUpdateMode: boolean = false
  ): Promise<void> => {
    const vendorToUse = vendorOverride || currentVendor;
  
    if (editMode && vendorToUse) {
      await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/v1/company/vendors/updateVendor`, {
        vendorId: vendorToUse.vendor_id,
        data: vendorToUse,
      });
  
      if (refetch) {
        await refetch();
        setCurrentVendor(vendorToUse);
      }
    }
  
    if (!skipToggleUpdateMode) {
      setUpdateMode(!updateMode);
    }
  };

  const deleteVendor = (refetch:any) => {
    axios.post(`${process.env.REACT_APP_SERVER_URL}/api/v1/company/vendors/deleteVendor`,
      {
        vendorId: currentVendor!.vendor_id,
      }
    ).then(() => {
      if (refetch) {
        refetch()
        setCurrentVendor(null)
      }
    })
  }

  return (
    <VendorContext.Provider value={{ currentVendor, handleUpdateVendor, updateMode, updater, toggleUpdateModeButton, deleteVendor, hideVendorDetails, vendorDetailsHidden }}>
      {children}
    </VendorContext.Provider>
  );
};
